import React, { useState } from 'react';
import { Container, Box } from '@mui/material';
import { SignInForm } from '../../components/auth/SignInForm';
import { useAuth } from '../../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

export const SignIn: React.FC = () => {
  const { state, signInWithGoogle, signInWithFacebook, signInWithPasskey, sendSmsCode, verifySmsCode, verifyTOTP } = useAuth();
  const [error, setError] = useState<string>();

  if (state.user) {
    return <Navigate to="/dashboard" />;
  }

  const handleGoogleSignIn = async () => {
    try {
      setError(undefined);
      await signInWithGoogle();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to sign in with Google');
    }
  };

  const handleFacebookSignIn = async () => {
    try {
      setError(undefined);
      await signInWithFacebook();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to sign in with Facebook');
    }
  };

  const handlePasskeySignIn = async () => {
    try {
      setError(undefined);
      await signInWithPasskey();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to sign in with passkey');
    }
  };

  const handleSendSmsCode = async (phoneNumber: string) => {
    try {
      setError(undefined);
      await sendSmsCode(phoneNumber);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to send SMS code');
    }
  };

  const handleVerifySmsCode = async (code: string) => {
    try {
      setError(undefined);
      await verifySmsCode(code);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to verify SMS code');
    }
  };

  const handleVerifyTOTP = async (email: string, code: string) => {
    try {
      setError(undefined);
      await verifyTOTP(email, code);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to verify TOTP code');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8 }}>
        <SignInForm
          onGoogleSignIn={handleGoogleSignIn}
          onFacebookSignIn={handleFacebookSignIn}
          onPasskeySignIn={handlePasskeySignIn}
          onSendSmsCode={handleSendSmsCode}
          onVerifySmsCode={handleVerifySmsCode}
          onVerifyTOTP={handleVerifyTOTP}
          error={error}
        />
      </Box>
    </Container>
  );
};

export default SignIn;
